import { Show } from "solid-js";
import type { Component } from "solid-js";
import { useAuth } from "@auth/session";

export const LoginScreen: Component = () => {
  const { state, signIn } = useAuth();

  console.log("LoginScreen rendering, auth state:", state.status);

  return (
    <div class="login-screen">
      <div class="login-backdrop"></div>
      <div class="login-card">
        <div class="login-logo">
          <img src="/logo.png" alt="HappyTidy" />
        </div>
        <h1 class="login-title">BackOffice Portal</h1>
        <p class="login-subtitle">Sign in with your HappyTidy Google account to manage operations.</p>

        <button
          type="button"
          class="login-button"
          onClick={() => void signIn()}
        >
          <i class="fa-brands fa-google"></i>
          <span>Continue with Google</span>
        </button>

        <Show when={state.error && state.status !== "authorized"}>
          <div class="login-error">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{state.error}</span>
          </div>
        </Show>

        <div class="login-footer">
          <p>© 2024 HappyTidy • Secure Access Portal</p>
        </div>
      </div>
    </div>
  );
};